import { useQuery, type UseQueryResult } from "@tanstack/react-query";

import { apiClient } from "@/lib/api-client";
import type { JsonApiProfileResponse, User } from "@/types/api";

interface UseCurrentUserResult {
  user: User | undefined;
  isLoading: boolean;
  isError: boolean;
  error: Error | null;
  isFetching: boolean;
  refetch: UseQueryResult<User>["refetch"];
}

function unwrapProfile(response: JsonApiProfileResponse): User {
  return {
    id: response.data.id,
    ...response.data.attributes,
  };
}

const getCurrentUser = async (): Promise<User> => {
  const response = await apiClient.get<JsonApiProfileResponse>("/apartmentiq/api/v1/profile");
  return unwrapProfile(response.data);
};

export const useCurrentUserApi = ({
  enabled = true,
}: { enabled?: boolean } = {}): UseCurrentUserResult => {
  const query = useQuery({
    queryKey: ["current-user"],
    queryFn: getCurrentUser,
    enabled,
    retry: false,
    staleTime: 1000 * 60 * 5,
  });

  return {
    user: query.data,
    isLoading: query.isLoading,
    isError: query.isError,
    error: query.error,
    isFetching: query.isFetching,
    refetch: query.refetch,
  };
};
